<script setup>
import SportLiveTvFilterDropdown from '@/sport-live-tv/components/sport-live-tv-filter-dropdown.vue';
import SportLiveTvScoresToggle from '@/sport-live-tv/components/sport-live-tv-scores-toggle.vue';
import SportLiveTvSortSelect from '@/sport-live-tv/components/sport-live-tv-sort-select.vue';
import SportLiveTvStatusTabs from '@/sport-live-tv/components/sport-live-tv-status-tabs.vue';

defineProps({
  categories: { type: Array, required: true },
  teams: { type: Array, required: true },
  selection: { type: Object, required: true },
  sort: { type: String, required: true },
  status: { type: String, required: true },
  scoresVisible: { type: Boolean, default: false },
});

const emit = defineEmits(['apply', 'clear', 'update:sort', 'update:status', 'toggle-scores']);
</script>

<template>
  <div class="sport-live-tv-filters">
    <div class="sport-live-tv-filters__controls">
      <SportLiveTvFilterDropdown :categories="categories" :teams="teams" :selection="selection" @clear="emit('clear')" @apply="emit('apply', $event)" />
      <SportLiveTvSortSelect :model-value="sort" @update:model-value="emit('update:sort', $event)" />
      <SportLiveTvStatusTabs :model-value="status" @update:model-value="emit('update:status', $event)" />
    </div>
    <SportLiveTvScoresToggle :visible="scoresVisible" @toggle="emit('toggle-scores')" />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 32px;

  @include mobile-sm-max {
    flex-direction: column;
    align-items: stretch;
  }

  &__controls {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;

    @include mobile-sm-max {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }
  }
}
</style>
